import { render } from "./AboutTech.vue?vue&type=template&id=1a5562a1&scoped=true"
import script from "./AboutTech.vue?vue&type=script&lang=js"
export * from "./AboutTech.vue?vue&type=script&lang=js"

import "./AboutTech.vue?vue&type=style&index=0&id=1a5562a1&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a5562a1"]])

export default __exports__